import { AudioSettingsComponent } from "./components/AudioSettingsComponent";
import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { WorldMapComponent } from "./components/WorldMapComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { ModalInventoryComponent } from "./components/ModalInventoryComponent";

// Expose the web components to the browser
window.customElements.define("audio-settings", AudioSettingsComponent);
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("world-map", WorldMapComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("game-modalinventory", ModalInventoryComponent);
